'use strict';

const queryString = window.location.search;
const resourceArchivePage = document.querySelector('.post-type-archive-resource');
class ResourcesFilter {
    
    // function to scroll to the filtered results
    scrollIntoView() {

        const mainHeaderHeight = document.querySelector('.main-header').offsetHeight;
        const filterResults = document.querySelector('article[data-post-type="resource"]');
        const elementPosition = filterResults.getBoundingClientRect().top;
        const offsetPosition = (elementPosition + window.pageYOffset - mainHeaderHeight) - 50;
        
        window.scrollTo({

            top: offsetPosition,
            behavior: 'smooth'

        });

    }

    constructor() {
        
        // if on resources archive page and there is an active filter
        if ( queryString.startsWith('?filters') && resourceArchivePage ) {

            window.addEventListener('load', () => {

                this.scrollIntoView();

            });
        }
    }
}

module.exports = ResourcesFilter;